// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__lYJDe","formControl":"styles_formControl__1wifH"};